import React from "react";
import { OptionType } from "../../../types/GeneralTypes";
import CheckboxGroup from "../../CheckboxGroup";
import styles from "./index.module.scss";

type PropsType = {
  assetTypes: Array<string>;
  // assetsEnabled: boolean; // whether "assets" is checked in EventMap
  selectedAssetTypes: Array<string>;
  onAssetTypeToggle: (val: string) => void;
  assetLabelMap: Record<string, string>; // optional mapping of asset type to custom label
};

const AssetLegend = ({
  assetTypes,
  selectedAssetTypes,
  onAssetTypeToggle,
  assetLabelMap
}: PropsType) => {
  const defaultAssetOptions: Array<OptionType> = assetTypes.map(type => ({
    label: assetLabelMap[type] || type,
    value: type
  }));

  // if (!assetsEnabled || assetTypes.length === 0) return null;

  return (
    <div className={styles.AssetLegend}>
      <p className={styles.AssetLegendLabel}>Asset Types</p>
      <CheckboxGroup
        small
        name="AssetTypes"
        options={defaultAssetOptions}
        checkboxValue={selectedAssetTypes}
        onChange={onAssetTypeToggle}
        assetLegend
      />
    </div>
  );
};

export default AssetLegend;
